import moment from 'moment';
import React from 'react';
import { Col, Label } from 'reactstrap';

import InputDate from '../InputDate/InputDate';

const updateDate = (value) => !!value ? moment(value).utc().format('YYYY-MM-DD') : '';

const InputDateField =  ({ 
    name, 
    label, 
    required, 
    sizeSm = 0, 
    sizeMd = 0, 
    sizeLg = 0, 
    _handleChange, 
    value 
}) => {
    const onChange = value => _handleChange(value, name);
    
    return (
        <React.Fragment>
            <Col sm={sizeSm} md={sizeMd} lg={sizeLg}>
                <Label>{label}</Label>
                <InputDate
                    type="date" 
                    onChange={onChange} 
                    name={name} 
                    id={name} 
                    placeholder="00/00/0000"
                    value={updateDate(value)}
                />
            </Col>
            </React.Fragment>
    )
};

export default InputDateField;
